import axios from 'axios';
import { env } from '../env';

type TimeTrackingRef = {
  [key: string]: {
    startTime: number;
  };
};

export default class AnalyticsService {
  private static timeTrackingRef: TimeTrackingRef = {};

  private static async sendAnalyticsEvent(
    type: string,
    timestamp: number,
    data: any,
  ): Promise<void> {
    await axios.post(
      `${env.REACT_APP_SPATIAL_MANAGER_API_URL}api/v1/analytics`,
      {
        type,
        timestamp,
        ...data,
      },
    );
  }

  static async track(
    type: string,
    timestamp: number,
    data: any,
  ): Promise<void> {
    try {
      // Check if this is a finish event for a paired type
      if (type.startsWith('FINISH') && this.timeTrackingRef[type]) {
        const startEvent = this.timeTrackingRef[type];
        const duration = new Date().getTime() - startEvent.startTime;

        const updatedData = {
          ...data,
          payload: { ...data.payload, duration },
        };

        console.log(
          `[AnalyticsService] ${type} [DURATION]: ${(duration / 1000).toFixed(
            2,
          )}s`,
        );

        await this.sendAnalyticsEvent(type, timestamp, {
          ...updatedData,
        });

        delete this.timeTrackingRef[type];
      }
      // Check if this is a start event for a paired type
      else if (type.startsWith('START')) {
        const finishType = type.replace('START', 'FINISH');
        this.timeTrackingRef[finishType] = {
          startTime: new Date().getTime(),
        };

        await this.sendAnalyticsEvent(type, timestamp, data);
      }
      // Regular event tracking
      else {
        await this.sendAnalyticsEvent(type, timestamp, data);
      }
    } catch (e) {
      console.error(`Can't track analytics: ${type}`);
    }
  }
}
